import {RestFilterModel, RestYiiFilterService} from 'gelios-ng-admin-components';
import {HttpParams} from '@angular/common/http';

export class BaseGridRestYiiFilterService extends RestYiiFilterService {
  public filterModel: RestFilterModel = {};

  getHttpParams(filterModel: RestFilterModel): HttpParams {
    return super.getHttpParams({...this.filterModel, ...filterModel});
  }
}
